<template>
  <div class="unbind_member">
    <div class="search_bar">
      <a-form layout="inline">
        <a-form-item label="用户id">
          <a-input
            v-model="searchUserUid"
            placeholder="请输入用户id"
            allowClear
            @pressEnter="handleSearch"
          />
        </a-form-item>
        <a-form-item label="会员卡号">
          <a-input
            v-model="searchCardNo"
            placeholder="请输入会员卡号"
            allowClear
            @pressEnter="handleSearch"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :dataSource="memberList"
      :loading="loading"
      :pagination="pagination"
      rowKey="uid"
      @change="handleTableChange"
    >
      <template slot="action" slot-scope="text, record">
        <a-button type="link" @click="handleUnbind(record)">解绑</a-button>
      </template>
    </a-table>
  </div>
</template>

<script>
import { message, Modal } from "ant-design-vue";
import { unbindMember, shopMemberList } from "@/api/storeApi.js";

export default {
  name: "unbindMember",
  data() {
    return {
      searchUserUid: "",
      searchCardNo: "",
      memberList: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      },
      columns: [
        { title: "会员卡号", dataIndex: "cardNo", ellipsis: true },
        { title: "用户id", dataIndex: "userUid", width: 120 },
        { title: "手机号", dataIndex: "phone", width: 150 },
        { title: "门店", dataIndex: "storeName", ellipsis: true },
        { title: "操作", scopedSlots: { customRender: "action" }, width: 100 },
      ],
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    loadList() {
      this.loading = true;
      let params = {};
      if (this.searchUserUid && this.searchUserUid.trim()) {
        params.userUid = Number(this.searchUserUid.trim());
      }
      if (this.searchCardNo && this.searchCardNo.trim()) {
        params.cardNo = this.searchCardNo.trim();
      }
      params.pageNo = this.pagination.current;
      params.pageSize = this.pagination.pageSize;

      shopMemberList(params)
        .then((res) => {
          console.log("[unbindMember] 请求成功, 响应:", res);
          this.loading = false;
          if (res.success === false) {
            message.error(res.info || "查询失败");
            this.memberList = [];
            return;
          }
          this.memberList = res.data || [];

          this.pagination.total = res.count || 0;
          message.info("查询成功");
        })
        .catch((err) => {
          this.loading = false;
          console.error("查询会员列表出错:", err);
          this.memberList = [];

        });
    },
    handleSearch() {
      this.loadList();
    },
    handleReset() {
      this.searchUserUid = "";
      this.searchCardNo = "";
      this.loadList();
    },
    handleTableChange(pag) {
      this.pagination.current = pag.current;
      this.pagination.pageSize = pag.pageSize;
      this.loadList();
    },
    handleUnbind(record) {
      Modal.confirm({
        title: "确认解绑",
        content: `确定要解绑卡号 ${record.cardNo} 吗？`,
        onOk: () => {
          return unbindMember({ cardNo: record.cardNo, uid: record.uid ,userUid:record.userUid })
            .then((res) => {
              if (res.success === false) {
                message.error(res.info);
              } else {
                message.success(res.info || "解绑成功");
                this.loadList();
              }
            })
            .catch((err) => {
              console.error("解绑出错:", err);
              message.error("解绑出错");
            });
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.unbind_member {
  box-sizing: border-box;
  width: 100%;
  background-color: #ffffff;
  padding: 16px;

  .search_bar {
    margin-bottom: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/unbindMember/unbindMember.vue